<template>
  <div class="content pop-content" style="padding-bottom: 50px;">
    <div class="carousel">
      <el-carousel trigger="click" height="300px" arrow="never" :interval="5000">
        <el-carousel-item v-for="item in imgs" :key="item.id">
          <div :style="'background-color:' + item.color">
            <img :src="item.url" alt="" class="banner" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="wrapper">
      <div class="tabs-wrapper" v-if="categories">
        <div class="tabs-mark-group">
          <span class="title">所有分类：</span>
          <ul class="">
            <li v-if="selectedCategory">{{ selectedCategory.name }}<i class="el-icon-arrow-right"></i></li>
            <li v-if="selectedSubCategory">{{ selectedSubCategory.name }}<i class="el-icon-arrow-right"></i></li>
            <li v-if="selectedthirdLevelCategory">
              {{ selectedthirdLevelCategory.name }}<i class="el-icon-arrow-right"></i>
            </li>
            <li v-for="(tag, index) in tags" :key="index">
              <el-tag closable type="info" effect="plain" @close="handleClose(index)">
                {{ tagGroups[index]["subs"][tag].name }}
              </el-tag>
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="subCategories && !Array.isArray(categories)">
          <span class="title">分类：</span>
          <ul class="">
            <li @click="editCategory('category', '')" :class="activeClass('selectedCategory', 'all')">
              全部
            </li>
            <li v-for="item in categories" @click="editCategory('category', item.code)" :class="activeClass('selectedCategory', item.code)" :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="subCategories && !Array.isArray(subCategories)">
          <ul class="">
            <li @click="editCategory('subCategory', '')" :class="activeClass('selectedSubCategory', 'all')">
              全部
            </li>
            <li v-for="item in subCategories" @click="editCategory('subCategory', item.code)" :class="activeClass('selectedSubCategory', item.code)" :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="tabs-group cate" v-if="thirdLevelCategories && !Array.isArray(thirdLevelCategories)">
          <ul class="">
            <li @click="editCategory('thirdLevelCategory', '')" :class="activeClass('selectedthirdLevelCategory', 'all')">
              全部
            </li>
            <li v-for="item in thirdLevelCategories" @click="editCategory('thirdLevelCategory', item.code)" :class="activeClass('selectedthirdLevelCategory', item.code)"
              :key="item.id">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div v-for="(tagGroup, index) in tagGroups" :key="index">
          <!-- 条件：不在选中的标签组和竞赛的标签组 -->
          <div class="tabs-group tab" v-if="
              Object.keys(tags).indexOf(index) == -1 &&
                tagGroup.scope.indexOf('course') > -1 &&
                Object.keys(tagGroup.subs).length > 0
            ">
            <div class="title">{{ tagGroup.name }}：</div>
            <ul>
              <li v-for="tag in tagGroup.subs" :key="tag.id">
                <el-tag type="info" effect="plain" @click="editTag(index, tag.id)">{{ tag.name }}</el-tag>
              </li>
              <!-- <li><el-tag type="info" effect="plain">暑期训练营</el-tag></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="codition-wrapper">
        <el-menu default-active="0" class="status_option" mode="horizontal" @select="selectStatus">
          <el-menu-item index="0">进行中</el-menu-item>
          <el-menu-item index="1">已结束</el-menu-item>
          <el-menu-item index="2" v-if="isLogin">已报名</el-menu-item>
        </el-menu>
        <!-- <div class="apply">
          <el-checkbox v-model="isApply" true-label="1" false-label="0" @change="handle">已报名</el-checkbox>
          <el-checkbox v-model="noApply" true-label="1" false-label="0" @change="handle">未报名</el-checkbox>
        </div> -->
      </div>
      <div class="contest-wrapper">
        <el-card shadow="never" class="contest_item" v-for="item in contests" :key="item.id">
          <div @click="detail(item.id)">
            <img :src="common.filepath(item.cover.middle)" alt="" />
            <!-- <img src="@/assets/imgs/logo.png" alt="" /> -->
            <div class="contest_info">
              <div class="title">
                <span>{{ item.title }}</span>
                <span class="tag_flag" :class="item.course | statusColor">{{ item.course | status }}</span>
                <!-- <span class="tag_official orange">官方比赛</span> -->
              </div>
              <div class="apply">
                报名时间:
                {{ common.date("Y-m-d H:i", item.course.buyStartTime) }} 至
                {{ common.date("Y-m-d H:i", item.course.buyExpiryTime) }}
              </div>
              <div class="contest">
                比赛时间:
                {{ common.date("Y-m-d H:i", item.course.testStartTime) }} 至
                {{ common.date("Y-m-d H:i", item.course.testExpiryTime) }}
                时长：{{ common.testTime(item.course.testExpiryTime - item.course.testStartTime) }}
              </div>
              <span class="sponsor" v-if="item.sponsor">{{ item.sponsor }}</span>
              <span class="member_number">参与人数：{{ item.studentNum }}</span>
            </div>
            <div class="contest_action">
              <!-- {{Object.keys(btnStatus).length,Object.keys(btn1Status).length}} -->
              <div class="btn_group" @click.stop>
                <el-button :type="btnStatus[item.id] != undefined ? btnStatus[item.id]['type'] : 'primary'"
                  :disabled="btnStatus[item.id] != undefined ? btnStatus[item.id]['disabled'] : false"
                  @click="methodsAction(btnStatus[item.id]['action'], btnStatus[item.id]['params'])" v-if="Object.keys(btnStatus).length > 0">
                  {{ btnStatus[item.id] != undefined ? btnStatus[item.id]["text"] : "进入比赛" }}</el-button>
                <el-button :type="btn1Status[item.id]['type']" :disabled="btn1Status[item.id]['disabled']"
                  @click="methodsAction(btn1Status[item.id]['action'], btn1Status[item.id]['params'])" v-if="Object.keys(btn1Status).length > 0 && btn1Status[item.id]"
                  class="btn_second">{{ btn1Status[item.id]["text"] }}</el-button>
              </div>

              <div class="lead_time" v-if="item.course.testStartTime * 1000 >= new Date().getTime()">
                距比赛<CountDown :endTime="Number(item.course.testStartTime)" endText="比赛开始"></CountDown>
              </div>
              <div class="lead_time" v-if="
                  item.course.testStartTime * 1000 < new Date().getTime() &&
                    item.course.testExpiryTime * 1000 >= new Date().getTime()
                ">
                结束倒计时<CountDown :endTime="Number(item.course.testExpiryTime)" endText="已结束"></CountDown>
              </div>
              <!-- <div class="lead_time none" v-else>已结束</div> -->
              <div class="transpond" @click="transferContest(item)" @click.stop v-if="rcTransfer">
                转发
              </div>
            </div>
          </div>
        </el-card>
        <el-dialog title="报名申请" :visible.sync="dialogTableVisible">
          <EntryForm @fetchData="handle" :competitionId="Number(applyId)" @close="close"></EntryForm>
        </el-dialog>
      </div>
      <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="paginator.itemCount" :page-size="20" v-show="paginator" v-if="paginator"
        hide-on-single-page></el-pagination>
    </div>
  </div>
</template>

<script>
import { getToken, getRcToken, getRcUid } from "@/utils/auth";
import { getContestIndex, applyCompetitions } from "@/api/course";
import { createReplay } from "@/api/contest.js";
import CountDown from "@/components/CountDown.vue";
import EntryForm from "@/components/EntryForm.vue";
export default {
  components: {
    CountDown,
    EntryForm
  },
  data() {
    return {
      code: "",
      contests: [],
      category: "",
      subCategory: "",
      thirdLevelCategory: "",
      selectedCategory: null,
      selectedSubCategory: null,
      selectedthirdLevelCategory: null,
      categories: null,
      subCategories: null,
      thirdLevelCategories: null,
      tagGroups: null,
      tags: null,
      coursesMember: null,
      teachers: null,
      times: null,
      coursesLockedMember: null,
      coursesRefundMember: null,
      joinCourses: null,
      selectedTags: null,
      page: 1,
      paginator: null,
      applyId: 0, //申请竞赛id
      dialogTableVisible: false,
      userId: "",
      checkList: [],
      isApply: 0,
      noApply: 0,
      isTimeUp: 2,
      show: true,
      isLogin: false,
      rcTransfer: false,
      btnStatus: {},
      btn1Status: {},
      imgs: [
        { id: 1, url: require("@/assets/imgs/1.png"), color: "#F4ECE1" },
        { id: 2, url: require("@/assets/imgs/2.png"), color: "#A9E8FF" },
        { id: 3, url: require("@/assets/imgs/3.png"), color: "#EFF4F7" },
        { id: 4, url: require("@/assets/imgs/4.png"), color: "#01C6D9" }
      ]
    };
  },
  created() {
    // this.handle();
    this.isLogin = getToken() ? true : false;
    this.rcTransfer = getRcToken() && getRcUid() ? true : false;
  },
  mounted() {
    var that = this;
    var btnStatus = this.btnStatus;
    var btn1Status = this.btn1Status;
    setInterval(function () {
      this.btnStatus = {};
      this.btn1Status = {};
      if (that.contests != []) {
        Object.values(that.contests).forEach(function (item, key) {
          var data = {};
          var data1 = {};
          if ([1, 2, 3].indexOf(that.statusType(item.course)) > -1 && !that.isLogin) {
            //比赛开始前 未登录

            data = {
              text: "报名",
              action: "login",
              params: "",
              disabled: false,
              type: "primary"
            };
          } else if ([4, 5].indexOf(that.statusType(item.course)) > -1 && !that.isLogin) {
            //比赛开始 未登录
            data = {
              text: "进入比赛",
              action: "login",
              params: "",
              disabled: false,
              type: "primary"
            };
          } else if (that.statusType(item.course) == 1 && that.isLogin) {
            //报名未开始
            data = {
              text: "报名",
              action: "",
              params: "",
              disabled: true,
              type: "info"
            };
          } else if (that.statusType(item.course) == 2 && that.teachers.indexOf(item.id) > -1 && that.isLogin) {
            //评委老师报名警告
            data = {
              text: "报名",
              action: "applyWarning",
              params: "",
              disabled: false,
              type: "primary"
            };
          } else if (
            that.statusType(item.course) == 2 &&
            item.course["buyCheck"] == 1 &&
            that.coursesMember.indexOf(item.id) > -1 &&
            that.coursesLockedMember.indexOf(item.id) > -1 &&
            that.isLogin
          ) {
            //报名期间 没报名  需要审核 提交申请 还未审核
            data = {
              text: "报名",
              action: "applyCheckWarning",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (
            that.statusType(item.course) == 2 &&
            item.course["buyCheck"] == 1 &&
            !(that.coursesMember.indexOf(item.id) > -1) &&
            that.isLogin
          ) {
            //报名期间 没报名  需要审核 未提交申请
            data = {
              text: "报名",
              action: "applyCheck",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (
            that.statusType(item.course) == 2 &&
            item.course.buyCheck == 0 &&
            !(that.coursesMember.indexOf(item.id) > -1) &&
            that.isLogin
          ) {
            //报名期间 没报名 不需要审核
            data = {
              text: "报名",
              action: "apply",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (
            that.statusType(item.course) == 2 &&
            that.coursesMember.indexOf(item.id) > -1 &&
            !(that.coursesLockedMember.indexOf(item.id) > -1) &&
            !(that.coursesRefundMember.indexOf(item.id) > -1) &&
            that.isLogin
          ) {
            //报名期间 报名 通过
            data = {
              text: "进入比赛",
              action: "detail",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (
            that.statusType(item.course) == 2 &&
            that.coursesMember.indexOf(item.id) > -1 &&
            !(that.coursesLockedMember.indexOf(item.id) > -1) &&
            that.coursesRefundMember.indexOf(item.id) > -1 &&
            that.isLogin
          ) {
            //报名期间 报名 没通过
            data = {
              text: "报名",
              action: "applyCheck",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (that.statusType(item.course) == 3 && !(that.coursesMember.indexOf(item.id) > -1) && that.isLogin) {
            //报名结束比赛未开始 没报名
            data = {
              text: "报名",
              action: "detail",
              params: item.id,
              disabled: true,
              type: "info"
            };
          } else if (that.statusType(item.course) == 3 && that.coursesMember.indexOf(item.id) > -1 && that.isLogin) {
            //报名结束比赛未开始 已报名
            data = {
              text: "进入比赛",
              action: "detail",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (that.statusType(item.course) == 4 && that.coursesMember.indexOf(item.id) > -1 && that.isLogin) {
            //比赛开始 有报名 进入比赛
            data = {
              text: "进入比赛",
              action: "enterContest",
              params: item.id,
              disabled: false,
              type: "primary"
            };
          } else if (that.statusType(item.course) == 4 && !(that.coursesMember.indexOf(item.id) > -1) && that.isLogin) {
            //比赛开始 没参与 进入详情
            data = {
              text: "进入比赛",
              action: "detail",
              params: item.id,
              disabled: true,
              type: "info"
            };
          } else if (
            that.statusType(item.course) == 5 &&
            // that.joinCourses.indexOf(Number(item.id)) > -1 &&
            that.isLogin
          ) {
            //比赛结束 没参与 参与重现赛
            data = {
              text: "查看比赛",
              action: "detail",
              params: item.id,
              disabled: false,
              type: "info"
            };
            if (that.times[item.id] == 0) {
              data1 = {
                text: "参与重现赛",
                action: "replay",
                params: item.id,
                disabled: false,
                type: "primary"
              };
            } else {
              data1 = {
                text: "回顾重现赛",
                action: "replayIndex",
                params: item.id,
                disabled: false,
                type: "primary"
              };
            }
          }
          // else if (
          //   that.statusType(item.course) == 5 &&
          //   !(that.joinCourses.indexOf(Number(item.id)) > -1) &&
          //   that.isLogin
          // ) {
          //   //比赛结束 有报名 参与重现赛
          //   data = {
          //     text: "查看比赛",
          //     action: "detail",
          //     params: item.id,
          //     disabled: false,
          //     type: "info"
          //   };
          //   data1 = {
          //     text: "参与重现赛",
          //     action: "replayIndex",
          //     params: item.id,
          //     disabled: false,
          //     type: "primary"
          //   };
          // }
          that.$set(btnStatus, item.id, data);
          if (Object.keys(data1).length > 0) {
            that.$set(btn1Status, item.id, data1);
          }
        });
      }
    }, 1000);
  },
  watch: {
    category() {
      this.subCategory = "";
      this.thirdLevelCategory = "";
      this.handle();
    },
    subCategory() {
      this.thirdLevelCategory = "";
      this.handle();
    },
    thirdLevelCategory() {
      this.handle();
    },
    selectedTags: {
      handler: "handle",
      immediate: true,
      deep: true
    }
  },
  methods: {
    //获取竞赛数据列表
    handle() {
      var id = 1;
      var params = {
        subCategory: this.subCategory,
        selectedthirdLevelCategory: this.thirdLevelCategory,
        "filter[type]": "all",
        "filter[price]": "all",
        "filter[currentLevelId]": "all",
        // "tag[tags][1]": 6,
        // "tag[tags][2]": 17,
        page: this.page,
        orderBy: "testStartTime",
        type: "contest"
      };
      if (this.isApply != 0) {
        params["isApply"] = this.isApply;
      }
      if (this.isTimeUp != 0) {
        params["isTimeUp"] = this.isTimeUp;
      }
      for (let key in this.selectedTags) {
        params["tag[tags][" + key + "]"] = this.selectedTags[key];
      }

      getContestIndex(this.category, params).then(response => {
        this.contests = response.data.courseSets;
        this.categories = response.data.categoryNav.categories;
        this.subCategories = response.data.categoryNav.subCategories;
        this.thirdLevelCategories = response.data.categoryNav.thirdLevelCategories;
        this.selectedCategory = response.data.categoryNav.selectedCategory;
        this.selectedSubCategory = response.data.categoryNav.selectedSubCategory;
        this.selectedthirdLevelCategory = response.data.categoryNav.selectedthirdLevelCategory;
        this.tags = response.data.tags;
        //重现赛次数
        this.times = response.data.times;
        this.coursesMember = response.data.coursesMember;
        this.coursesLockedMember = response.data.coursesLockedMember;
        this.coursesRefundMember = response.data.coursesRefundMember;
        this.joinCourses = response.data.joinCourses;
        this.teachers = response.data.teachers;
        this.userId = response.data.userId;
        this.paginator = response.data.paginator;
        var tagGroups = response.data.categoryNav.tagGroups;
        var tagArr = response.data.categoryNav.tags;
        var tagGroupArr = {};
        for (let i = 0; i < tagGroups.length; i++) {
          tagGroupArr[tagGroups[i].id] = tagGroups[i];
        }
        this.tagGroups = tagGroupArr;
      });
    },
    methodsAction(acton, params) {
      this[acton](params);
    },
    //转态切换（进行中、已结束）
    selectStatus(key) {
      if (key == 0) {
        this.isTimeUp = 2;
        this.isApply = 0;
      }
      if (key == 1) {
        this.isTimeUp = 1;
        this.isApply = 0;
      }
      if (key == 2) {
        this.isApply = 1;
        this.isTimeUp = 0;
      }
      this.handle();
    },
    login() {
      this.$router.push({ name: "login", params: { type: "login" } });
    },
    //无审核转态下报名
    apply(id) {
      //     this.$router.push({
      //   name: "competition",
      //   params: { competitionId: id }
      // });
      this.$confirm("是否报名参加比赛?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var params = {
          targetType: "course",
          targetId: id
        };

        applyCompetitions(params).then(response => {
          // 
          if (response.code == 200) {
            this.$message.success({
              message: "报名成功"
            });
            this.handle();
          }
        });
      });
    },
    detail(id) {
      this.$router.push({
        name: "competition-introduce",
        params: { competitionId: id }
      });
    },
    replayIndex(id) {
      this.$router.push({
        name: "replay-index",
        params: { competitionId: id, times: this.times[id], classroomId: 0 }
      });
    },
    replay(competition_id) {
      this.$confirm("是否报名参加重现赛?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          classroom_id: 0,
          competition_id: competition_id,
          replay_type: 1
        };
        createReplay(params).then(response => {
          this.$router.push({
            name: "replay-introduce",
            params: {
              classroomId: 0,
              competitionId: competition_id,
              times: response.data,
              replay_type: 1
            }
          });
        });
      });
    },

    enterContest(id) {
      this.$router.push({
        name: "competition-index",
        params: { competitionId: id }
      });
    },
    applyWarning() {
      this.$message.warning({
        message: "评委老师禁止参赛"
      });
    },
    //审核转态下报名
    applyCheck(id) {
      this.applyId = id;
      this.dialogTableVisible = true;
    },
    applyCheckWarning() {
      this.$message.warning({
        message: "报名申请已提交，请等待审核"
      });
    },
    close() {
      this.dialogTableVisible = false;
    },
    pageChange(val) {
      this.page = val;
      this.handle();
    },
    editCategory(level, code) {
      this[level] = code;
    },
    editTag(group, id) {
      this.selectedTags = { ...this.tags };
      this.selectedTags[group] = id;
    },
    activeClass(level, code) {
      if (this[level] && this[level]["code"] == code) {
        return "active";
      } else if (!this[level] && code == "all") {
        return "active";
      } else {
        return "";
      }
    },
    handleClose(group) {
      var tags = { ...this.selectedTags };
      delete tags[group];
      this.selectedTags = tags;
    },

    statusType(value) {
      var time = new Date().getTime() / 1000;
      var status = 0;
      switch (true) {
        case time < value.buyStartTime:
          status = 1;
          break;
        case time > value.buyStartTime && time < value.buyExpiryTime:
          status = 2;
          break;
        case time > value.buyExpiryTime && time < value.testStartTime:
          status = 3;
          break;
        case time > value.testStartTime && time < value.testExpiryTime:
          status = 4;
          break;
        default:
          status = 5;
      }
      return status;
    },
    transferContest: function (item) {
      let newPage = this.$router.resolve({
        name: "competition-introduce",
        params: {
          competitionId: item.id
        }
      });
      let params = {
        title: item.title,
        text: item.summary,
        thumb_url: this.common.filepath(item.cover.middle),
        message_link: newPage.href
      };
      this.common.transferUrl(params);
    }
  },
  filters: {
    status: function (value) {
      // let status = '';
      var time = new Date().getTime() / 1000;
      switch (true) {
        case time < value.buyStartTime:
          status = "未开始";
          break;
        case time > value.buyStartTime && time < value.buyExpiryTime:
          status = "报名中";
          break;
        case time > value.buyExpiryTime && time < value.testStartTime:
          status = "待开始";
          break;
        case time > value.testStartTime && time < value.testExpiryTime:
          status = "比赛中";
          break;
        default:
          status = "已结束";
      }
      return status;
    },
    statusColor: function (value) {
      var color = "";
      var time = new Date().getTime() / 1000;
      switch (true) {
        case time < value.buyStartTime:
          color = "gray";
          break;
        case time > value.buyStartTime && time < value.buyExpiryTime:
          color = "green";
          break;
        case time > value.buyExpiryTime && time < value.testStartTime:
          color = "orange";
          break;
        case time > value.testStartTime && time < value.testExpiryTime:
          color = "blue";
          break;
        default:
          color = "gray";
      }
      return color;
    }
  }
};
</script>

<style scoped lang="less">
.carousel {
  .banner {
    width: 1200px;
    height: 300px;
    display: block;
    margin: 0 auto;
  }
}
.wrapper {
  width: 1000px;
  margin: 20px auto 0;
  ul li {
    display: inline-block;
  }
  .tabs-wrapper {
    border: 1px solid #d7d7d7;
    border-radius: 4px;
    margin-bottom: 30px;
    background-color: #fff;
    box-sizing: border-box;
    ul {
      margin-left: 120px;
    }
    .active {
      background-color: #229eff;
      color: #fff;
    }
    li {
      margin-right: 20px;
    }
    .tabs-mark-group {
      height: 44px;
      line-height: 44px;
      li {
        padding-left: 5px;
        padding-right: 5px;
      }
      .title {
        width: 100px;
        padding: 12px 10px;
        float: left;
        line-height: 20px;
      }
    }
    .tabs-group {
      line-height: 50px;

      border-top: 1px dashed #d7d7d7;
      .el-tag {
        cursor: pointer;
        color: #000;
      }
    }
    .cate li {
      // margin: 10px 11px;
      padding: 0 11px;
      line-height: 30px;
      border-radius: 5px;
      cursor: pointer;
    }
    .title {
      float: left;
      padding: 15px 10px;
      width: 100px;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: normal;
      line-height: 20px;
    }
    .tab {
      background: rgb(245, 245, 245);
      border-top: 1px solid #d7d7d7;
    }
  }
  .codition-wrapper {
    overflow: hidden;

    .status_option {
      width: 350px;
      float: left;
      border-bottom: none;
    }
    .apply {
      float: right;
      line-height: 55px;
    }
  }
  .contest-wrapper {
    .contest_item {
      //   height: 150px;
      box-sizing: border-box;
      margin-bottom: 20px;
      cursor: pointer;
      /deep/ .el-card__body {
        overflow: hidden;
        img {
          width: 120px;
          height: 120px;
          margin-right: 15px;
          float: left;
        }
        .contest_info {
          width: 600px;
          float: left;
          color: #7f7f7f;
          .title {
            font-size: 16px;
            .tag_flag {
              position: relative;
              display: inline-block;
              padding: 5px 18px 5px 10px;
              font-size: 12px;
              margin-left: 10px;
              color: #fff;
            }
            .tag_flag::after {
              content: "";
              position: absolute;
              top: 0;
              right: 0px;
              display: inline-block;
              // background-color: #f59a23;
              width: 0;
              height: 0;
              border-width: 13px;
              border-style: solid;
              border-color: transparent #fff transparent transparent;
            }

            .tag_official {
              display: inline-block;
              padding: 5px 10px;
              font-size: 12px;
              margin-left: 10px;
              color: #fff;
              border-radius: 2px;
            }
            .green {
              background-color: #33ccb0;
            }
            .blue {
              background-color: #409eff;
            }
            .orange {
              background-color: #f59a23;
            }
            .gray {
              background-color: #cacaca;
            }
          }
          .apply {
            position: relative;
            margin-top: 10px;
            padding-left: 25px;
            line-height: 20px;
          }
          .contest {
            position: relative;
            margin-top: 10px;
            padding-left: 25px;
            line-height: 20px;
          }
          .sponsor {
            display: inline-block;
            min-width: 20px;
            position: relative;
            margin-top: 10px;
            margin-right: 10px;
            padding-left: 25px;
            line-height: 20px;
          }
          .member_number {
            display: inline-block;
            position: relative;
            margin-top: 10px;
            padding-left: 25px;
            line-height: 20px;
          }
          .apply::before {
            content: " ";
            width: 22px;
            height: 22px;
            background: url("../../assets/imgs/u152.png") no-repeat;
            background-size: 22px 22px;
            position: absolute;
            top: -3px;
            left: 0;
            z-index: 2;
          }
          .contest::before {
            content: " ";
            width: 22px;
            height: 22px;
            background: url("../../assets/imgs/u140.png") no-repeat;
            background-size: 22px 22px;
            position: absolute;
            top: -3px;
            left: 0;
            z-index: 2;
          }
          .sponsor::before {
            content: " ";
            width: 22px;
            height: 22px;
            background: url("../../assets/imgs/u153.png") no-repeat;
            background-size: 22px 22px;
            position: absolute;
            top: -3px;
            left: 0;
            z-index: 2;
          }
          .member_number::before {
            content: " ";
            width: 22px;
            height: 22px;
            background: url("../../assets/imgs/u156.png") no-repeat;
            background-size: 22px 22px;
            position: absolute;
            top: -3px;
            left: 0;
            z-index: 2;
          }
        }
        .contest_action {
          width: 200px;
          height: 120px;
          float: right;
          position: relative;
          .btn_group {
            text-align: right;
            .btn_second {
              margin-top: 10px;
            }
          }
          > * {
            float: right;
          }
          .el-button {
            width: 120px;
          }
          .lead_time {
            width: 100%;
            margin: 20px 0;
            text-align: right;
            &.none {
              visibility: hidden;
            }
          }

          .transpond {
            position: absolute;
            padding-left: 25px;
            right: 0;
            bottom: 0;
            cursor: pointer;
          }
          .transpond::before {
            content: "";
            width: 22px;
            height: 22px;
            background: url("../../assets/imgs/u362.png") no-repeat;
            background-size: 22px 22px;
            position: absolute;
            top: -3px;
            left: 0px;
            z-index: 2;
          }
        }
      }
    }
  }
}
.tag_flag {
}
</style>
